/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_Months_LabelInputs */

const es_admin_billing_batch_months_label = /** @type {(inputs: Admin_Billing_Batch_Months_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meses a pagar`)
};

const en_admin_billing_batch_months_label = /** @type {(inputs: Admin_Billing_Batch_Months_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Months to pay`)
};

/**
* | output |
* | --- |
* | "Months to pay" |
*
* @param {Admin_Billing_Batch_Months_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_months_label = /** @type {((inputs?: Admin_Billing_Batch_Months_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Months_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_months_label(inputs)
	return en_admin_billing_batch_months_label(inputs)
});
export { admin_billing_batch_months_label as "admin.billing.batch.months_label" }